"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenInvoicesByWeek = void 0;
const array_1 = require("./array");
const math_1 = require("./math");
const NOT_FOUND = -1;
const flattenAdjustments = (adjustments) => adjustments
    .reduce((adjustmentsList, adjustment) => {
    const existingAdjustmentIndex = adjustmentsList
        .findIndex(({ label }) => label === adjustment.label);
    return existingAdjustmentIndex === NOT_FOUND
        ? [
            ...adjustmentsList,
            adjustment,
        ]
        : [
            ...adjustmentsList.slice(0, existingAdjustmentIndex),
            ...adjustmentsList.slice(existingAdjustmentIndex + 1),
            {
                label: adjustmentsList[existingAdjustmentIndex].label,
                amount: adjustmentsList[existingAdjustmentIndex].amount + adjustment.amount,
            },
        ];
}, []);
const getTotals = (shifts, adjustments = []) => {
    const shiftTotals = shifts.reduce((runningTotals, shift) => ({
        hours: runningTotals.hours + (shift.hours || 0),
        orders: runningTotals.orders + shift.orders,
        pay: runningTotals.pay + shift.pay,
    }), {
        hours: 0,
        orders: 0,
        pay: 0,
    });
    return {
        hours: math_1.round(shiftTotals.hours),
        orders: shiftTotals.orders,
        pay: math_1.round(shiftTotals.pay),
        adjustments: adjustments.reduce((total, { amount }) => total + amount, 0),
    };
};
const flattenInvoicesByWeek = (startOfWeek, allInvoices) => {
    const endOfWeek = startOfWeek.endOf('week');
    const invoices = allInvoices
        .filter(({ start }) => start.hasSame(startOfWeek, 'week'))
        .map((invoice) => (Object.assign(Object.assign({}, invoice), { shifts: invoice.shifts.map((shift) => (Object.assign(Object.assign({}, shift), { start: shift.start < startOfWeek
                ? startOfWeek
                : shift.start, end: shift.end > endOfWeek
                ? endOfWeek
                : shift.end }))) })));
    const shifts = array_1.flattenByObjectKey(invoices, (invoice) => invoice.shifts);
    const adjustments = flattenAdjustments(array_1.flattenByObjectKey(invoices, (invoice) => invoice.adjustments));
    const totals = getTotals(shifts, adjustments);
    return {
        shifts,
        adjustments,
        totals,
    };
};
exports.flattenInvoicesByWeek = flattenInvoicesByWeek;
//# sourceMappingURL=stats.js.map